import Vue from "vue";
import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vClickOutside from "v-click-outside";
import router from "./router/index";
import VueMultiselect from "vue-multiselect";
import mitt from "mitt";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueFormGenerator from "vue-form-generator";
import "./design/forms-generator.scss";
import Dropdown from "@/components/dropdown";
import Loader from "@/components/ui/loader";
import Button from "@/components/ui/button";
import FieldBInput from "@/components/custom-fields/b-input";
import FieldBRadios from "@/components/custom-fields/b-radios";
import FieldBRadio from "@/components/custom-fields/b-radio";
import FieldBCheckbox from "@/components/custom-fields/b-checkbox";
import FieldDatePicker from "@/components/custom-fields/datepicker";
import FieldMultiselect from "@/components/custom-fields/multiselect";
import axios from "./helpers/axios";
import Config from "./helpers/config";

VueFormGenerator.validators.resources.fieldIsRequired = "Ce champ est requis!";
//VueFormGenerator.validators.resources.textTooSmall = "الحد الأدنى {1} حرف";
VueFormGenerator.validators.resources.textTooBig = "{1} caractères au max";

import "@/design/index.scss";

import store from "@/state/store";

import App from "./App.vue";

import { configureFakeBackend } from "./helpers/fake-backend";
configureFakeBackend();

const socketConnection = SocketIO(Config.END_POINT);

Vue.use(
    new VueSocketIO({
        connection: socketConnection
    })
);

Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(Toast, {
    position: "top-center",
    transition: "Vue-Toastification__fade",
    maxToasts: 20,
    newestOnTop: true,
    hideProgressBar: true
});
Vue.component("multiselect", VueMultiselect);
Vue.use(VueFormGenerator);
Vue.component("dropdown", Dropdown);
Vue.component("ea-loader", Loader);
Vue.component("q-button", Button);
Vue.component("fieldBInput", FieldBInput);
Vue.component("fieldBRadios", FieldBRadios);
Vue.component("fieldBRadio", FieldBRadio);
Vue.component("fieldBCheckbox", FieldBCheckbox);
Vue.component("fieldDatepicker", FieldDatePicker);
Vue.component("fieldMultiselect", FieldMultiselect);

const emitter = mitt();
Vue.prototype.mitt = emitter;

Vue.prototype.$axios = axios;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
